"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Box_1 = __importDefault(require("@material-ui/core/Box"));
var components_1 = require("@xyo-network/coin-forms/build/lib/components");
var components_2 = require("@xyo-network/coin-mapbox/build/lib/components");
var partial_1 = __importDefault(require("lodash/partial"));
var react_1 = __importStar(require("react"));
var invoke_1 = __importDefault(require("lodash/invoke"));
exports.DropFormFields = function (_a) {
    var values = _a.values, accessToken = _a.accessToken;
    var emailRef = react_1.useRef(null);
    var quadkeyRef = react_1.useRef(null);
    var scrollIntoView = function (ref) { return function () {
        setTimeout(function () { return invoke_1.default(ref.current, 'scrollIntoView'); }, 0);
    }; };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(components_1.FormField, { label: "Amount", name: "amount", type: "number", margin: "normal", variant: "outlined", fullWidth: true }),
        react_1.default.createElement(components_1.SliderField, { name: "amount", min: 10, max: values.maxAmount }),
        react_1.default.createElement(components_1.FormField, { label: "Quantity", name: "quantity", type: "number", margin: "normal", variant: "outlined", fullWidth: true }),
        react_1.default.createElement(components_1.SliderField, { name: "quantity", min: 1, max: values.maxQuantity }),
        react_1.default.createElement(components_1.FormField, { label: "Title", name: "title", margin: "normal", variant: "outlined", fullWidth: true }),
        react_1.default.createElement(Box_1.default, { pt: 2 }),
        react_1.default.createElement(components_1.FormField, { label: "Message", name: "message", margin: "normal", variant: "outlined", rows: 4, rowsMax: 4, multiline: true, fullWidth: true }),
        react_1.default.createElement(Box_1.default, { pt: 2 }),
        react_1.default.createElement(components_1.UploadField, { name: "base64Image", onUpload: partial_1.default(components_1.validateSize, 512, 512) }),
        react_1.default.createElement(Box_1.default, { pt: 2 }),
        react_1.default.createElement(components_1.FormField, { label: "Info URL", name: "link", margin: "normal", variant: "outlined", fullWidth: true }),
        react_1.default.createElement(Box_1.default, { pt: 2 }),
        react_1.default.createElement("div", null,
            react_1.default.createElement(components_1.CheckboxField, { name: "restrictToEmail", label: "Restrict To Email", onClick: scrollIntoView(emailRef) })),
        values.restrictToEmail && (react_1.default.createElement(components_1.FormField, { ref: emailRef, onClick: scrollIntoView(emailRef), label: "Email", name: "email", margin: "normal", type: "email", variant: "outlined", fullWidth: true })),
        react_1.default.createElement(Box_1.default, { pt: 2 }),
        react_1.default.createElement("div", null,
            react_1.default.createElement(components_1.CheckboxField, { name: "restrictToQuadkey", label: "Restrict To Quadkey", onClick: scrollIntoView(quadkeyRef) })),
        values.restrictToQuadkey && (react_1.default.createElement(components_2.SelectQuadkey, { label: "Quadkey", variant: "outlined", name: "quadkey", margin: "normal", onClick: scrollIntoView(quadkeyRef), ref: quadkeyRef, fullWidth: true, mapProps: {
                id: 'main-drop-form',
                accessToken: accessToken,
            } })),
        react_1.default.createElement(Box_1.default, { pt: 2 }),
        react_1.default.createElement(Box_1.default, { pt: 2 })));
};
//# sourceMappingURL=Fields.js.map